import axios, { AxiosResponse } from 'axios';

import { BasicRequestConfig, OpenRequest } from 'ui/types';

import { normaliseLegacyQuestionTypes } from 'utils/api/legacyQuestionType';
import { RequestOptions, APIRequest } from 'utils/api/types';

import { BACKGROUND_REQUEST_HEADER, BACKGROUND_REQUEST_VALUE } from 'core/constants';

import { env } from 'config';

export default class BaseAPI {
  protected request<T>(options: RequestOptions): APIRequest<T> {
    const {
      baseURL = env.REACT_APP_API_URL,
      url,
      method,
      params = {},
      data = {},
      headers = {},
      authorization,
      timeout = undefined,
      onUploadProgress = undefined,
      cancelTokenSource = undefined,
      responseType = undefined,
      signal = undefined,
      background = false,
    } = options;

    if (authorization) {
      headers.authorization = authorization;
    }
    if (background) {
      headers[BACKGROUND_REQUEST_HEADER] = BACKGROUND_REQUEST_VALUE;
    }
    const config = {
      method,
      url,
      params,
      data,
      headers,
      onUploadProgress,
      timeout,
      baseURL,
      withCredentials: true,
      xsrfHeaderName: 'X-CSRFToken',
      xsrfCookieName: env.REACT_APP_CSRF_COOKIE_NAME || 'csrftoken',
      cancelToken: cancelTokenSource?.token,
      responseType,
      signal,
      exposedHeaders: ['Location'],
    };
    const axiosRequest = (): Promise<AxiosResponse<T>> =>
      axios(config).then((response) => {
        // Folds the pre-rename `procedures` question type back onto `repeating_group` (ENG-12126).
        normaliseLegacyQuestionTypes(response.data);
        return response;
      });
    axiosRequest.config = config;

    return axiosRequest;
  }

  protected open(config: BasicRequestConfig): OpenRequest {
    const { baseURL = env.REACT_APP_API_URL, params = {}, url } = config;
    let { finalURL } = config;
    if (!finalURL) {
      const queryString = new URLSearchParams();
      Object.entries(params).forEach(([name, value]) => queryString.append(name, value));
      const buildUrl = new URL(url, baseURL);
      // @ts-ignore
      buildUrl.search = queryString;
      finalURL = buildUrl.toString();
    }
    const result = (() => window.open(finalURL) as unknown) as OpenRequest;
    result.config = config;
    return result;
  }
}
